import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface BairroRegiao {
    id: number | null
    nomeBairro: string
    idCidade: number | null
    nomeCidade: string | null
    taxaEntrega: string
    taxaEntregaNoturna: string | null
    minimoEntregaGratis: string | null
    versao: number | null
}

export interface CidadeView {
    id: number
    nome: string
    nomeCompleto: string | null
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

const ErroRequisicao = function (error: { message?: string }): string | false {
    if (error.message === "Network Error") return "Verifique sua conexão!"
    if (error.message) return "Erro: " + error.message
    return false
}

export const obterBairros = async function (
    authorization: string,
    idEstabelecimento: number
): Promise<BairroRegiao[] | ErroApi> {
    try {
        const response = await api
            .get<BairroRegiao[] | RespostaErroRaw>(`endereco/bairros/${idEstabelecimento}`, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as BairroRegiao[]
    } catch (error) {
        RegistrarLogErro(error, "obterBairros", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const salvarBairros = async function (
    authorization: string,
    idEstabelecimento: number,
    bairros: BairroRegiao[]
): Promise<BairroRegiao[] | ErroApi> {
    try {
        const response = await api
            .post<BairroRegiao[] | RespostaErroRaw>(
                `endereco/bairros/${idEstabelecimento}`,
                bairros,
                { headers: { "Content-Type": "application/json", Authorization: authorization } }
            )
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as BairroRegiao[]
    } catch (error) {
        RegistrarLogErro(error, "salvarBairros", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const excluirBairros = async function (
    authorization: string,
    idEstabelecimento: number,
    bairros: BairroRegiao[]
): Promise<BairroRegiao[] | ErroApi> {
    try {
        const response = await api
            .delete<BairroRegiao[] | RespostaErroRaw>(`endereco/bairros/${idEstabelecimento}`, {
                data: bairros,
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as BairroRegiao[]
    } catch (error) {
        RegistrarLogErro(error, "excluirBairros", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const obterCidadesEstabelecimento = async function (
    authorization: string,
    idEstabelecimento: number
): Promise<CidadeView[] | ErroApi> {
    try {
        const response = await api
            .get<CidadeView[] | RespostaErroRaw>(`endereco/cidades/${idEstabelecimento}`, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as CidadeView[]
    } catch (error) {
        RegistrarLogErro(error, "obterCidadesEstabelecimento", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const obterTodasCidades = async function (
    authorization: string
): Promise<CidadeView[] | ErroApi> {
    try {
        const response = await api
            .get<CidadeView[] | RespostaErroRaw>("endereco/cidades/todas", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as CidadeView[]
    } catch (error) {
        RegistrarLogErro(error, "obterTodasCidades", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const adicionarCidadeEstabelecimento = async function (
    authorization: string,
    idEstabelecimento: number,
    idCidade: number
): Promise<CidadeView[] | ErroApi> {
    try {
        const response = await api
            .post<CidadeView[] | RespostaErroRaw>(
                `endereco/cidades/${idEstabelecimento}`,
                { idCidade },
                { headers: { "Content-Type": "application/json", Authorization: authorization } }
            )
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as CidadeView[]
    } catch (error) {
        RegistrarLogErro(error, "adicionarCidadeEstabelecimento", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const removerCidadeEstabelecimento = async function (
    authorization: string,
    idEstabelecimento: number,
    idCidade: number
): Promise<CidadeView[] | ErroApi> {
    try {
        const response = await api
            .delete<CidadeView[] | RespostaErroRaw>(`endereco/cidades/${idEstabelecimento}`, {
                data: { idCidade },
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as CidadeView[]
    } catch (error) {
        RegistrarLogErro(error, "removerCidadeEstabelecimento", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
